/**
 * 消息撤回：服务端撤回时追加一条撤回标记（带新序号，增量同步即可收到），标记本身不展示，
 * 只用来把它指向的原消息显示为“已撤回”。整页重新加载时服务端也会直接把原消息标为已撤回。
 */

/** 发出后多久内可以撤回，与服务端一致。 */
export const RECALL_WINDOW_MS = 2 * 60 * 1000;

interface Recallable {
  id: string;
  quote?: { id: string; recalled?: boolean; text: string };
  recallOf?: string;
  recalled?: boolean;
  text: string;
}

/** 去掉撤回标记，并把被撤回的消息与指向它们的引用标成已撤回、清空内容。 */
export function applyRecalls<T extends Recallable>(items: readonly T[]): T[] {
  const recalled = new Set(items.filter((item) => item.recallOf).map((item) => item.recallOf as string));
  for (const item of items) if (item.recalled) recalled.add(item.id);
  const out: T[] = [];
  for (const item of items) {
    if (item.recallOf) continue;
    let next = item;
    if (recalled.has(item.id) && !(item.recalled && item.text === '')) {
      next = { ...item, recalled: true, text: '', ...('attachments' in item ? { attachments: [] } : {}) };
    }
    if (next.quote && recalled.has(next.quote.id) && !next.quote.recalled) {
      next = { ...next, quote: { ...next.quote, recalled: true, text: '' } };
    }
    out.push(next);
  }
  return out;
}

/** 本人发出、未撤回且仍在撤回时限内的消息才显示“撤回”。 */
export function canRecallAt(sentAt: string, now: number): boolean {
  const time = Date.parse(sentAt);
  return Number.isFinite(time) && now - time < RECALL_WINDOW_MS;
}
